const state={
  userInfo:{},
  signInfo:{},
  userStep:{}
}
const getters={
  getUserStep(state){
    return state.userStep
  }
}
const actions={

}
const mutations={
  setUserInfo (state,data) {
    state.userInfo = Object.assign({},data)
  },
  setSignInfo(state,data) {
    state.signInfo = Object.assign({},data)
  },
  setUserStep(state,data){
    state.userStep = Object.assign({},data)
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/newYear/index.js